import { CountDashboardStoriesMeta, CountDashboardStoriesPayload } from 'types/store/CountDashboardStories';
import { createAsyncReducer } from 'utils/Redux';

import { countDashboardStoriesActions } from '../actions';

export default createAsyncReducer<CountDashboardStoriesMeta, CountDashboardStoriesPayload>(countDashboardStoriesActions);
